export const planningMonday = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return '';
  const date = new Date(`${value}T12:00:00Z`);
  if (Number.isNaN(date.getTime())) return '';
  date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7);
  return date.toISOString().slice(0, 10);
};

export const latestPlanningWeek = () => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date());
  const p = Object.fromEntries(parts.map(part => [part.type, part.value]));
  const date = new Date(`${p.year}-${p.month}-${p.day}T12:00:00Z`);
  if (date.getUTCDay() === 0 && Number(p.hour) >= 1) date.setUTCDate(date.getUTCDate() + 1);
  return planningMonday(date.toISOString().slice(0, 10));
};

export const planningWeekLabel = value => value
  ? new Date(`${value}T12:00:00Z`).toLocaleDateString('fr-FR', {
    timeZone: 'Europe/Paris', day: 'numeric', month: 'long', year: 'numeric',
  }) : '—';